"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useParseBlocksContent;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_PROPS = {
  content: '',
  options: {
    blockable: true
  },
  parsers: {
    block: function block(content) {
      return content.split('\n');
    }
  },
  show: true
};

function useParseBlocksContent(_ref) {
  var content = _ref.content,
      _parsers = _ref.parsers,
      _options = _ref.options,
      show = _ref.show;

  var _DEFAULT_PROPS$option = _objectSpread(_objectSpread({}, DEFAULT_PROPS.options), _options),
      blockable = _DEFAULT_PROPS$option.blockable;

  var _DEFAULT_PROPS$parser = _objectSpread(_objectSpread({}, DEFAULT_PROPS.parsers), _parsers),
      blockParser = _DEFAULT_PROPS$parser.block;

  var blocksContent = (0, _react.useMemo)(function () {
    var _blocksContent = [];
    _blocksContent = show && (blockable ? blockParser(content) : [content]);
    return _blocksContent;
  }, [show, blockable, blockParser, content]);
  return blocksContent;
}

;
useParseBlocksContent.propTypes = {
  /** Text to be edited whether file, section or block */
  content: _propTypes.default.string.isRequired,

  /** Options for the editor */
  options: _propTypes.default.shape({
    /** Parse content by blocks using blockParser */
    blockable: _propTypes.default.bool
  }),

  /** Functions to parse the content into sections and blocks */
  parsers: _propTypes.default.shape({
    /** Function to parse the content into blocks */
    block: _propTypes.default.func
  })
};
useParseBlocksContent.defaultProps = DEFAULT_PROPS;